<template>
  <div ref="root" class="hero-fb" data-hero-fallback="1">
    <div class="hero-fb__stage" :style="stageStyle">
      <canvas ref="cv" class="hero-fb__cv" width="1024" height="700" />
    </div>
  </div>
</template>

<script>
import { drawPixelPerson } from '@/game/pixelCharacter'

// 背景图 (home-map-clean.jpg, 1024x700) 坐标系；可行走区域 = 深色石板走廊
const IMG_W = 1024
const IMG_H = 700
const BOX = { x0: 352, x1: 462, y0: 205, y1: 600 }
const SPRITE_SCALE = 4.57
const SPEED = 120 // 背景图像素 / 秒

/**
 * 无 WebGL（Pixi 初始化失败）/ 低端设备时的 Canvas 2D 兜底：
 * setInterval 驱动（不依赖 rAF、不依赖 Pixi），访客在走廊内随机漫步，无名牌。
 */
export default {
  name: 'HeroFallback',
  data () {
    return { scale: 1, ox: 0, oy: 0 }
  },
  computed: {
    stageStyle () {
      return {
        width: IMG_W + 'px',
        height: IMG_H + 'px',
        backgroundImage: 'url(/home-map-clean.jpg)',
        backgroundSize: '100% 100%',
        transform: `translate(${this.ox}px, ${this.oy}px) scale(${this.scale})`
      }
    }
  },
  mounted () {
    this.x = 420
    this.y = 272
    this.facing = 'down'
    this.phase = 0
    this.target = null
    this.pauseUntil = 0
    this.last = performance.now()
    this.sprite = document.createElement('canvas')
    this.sprite.width = 16
    this.sprite.height = 16
    this.layout()
    this.ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(() => this.layout()) : null
    if (this.ro) this.ro.observe(this.$refs.root)
    window.addEventListener('resize', this.layout)
    this.timer = setInterval(() => this.tick(), 40)
    this.tick()
  },
  beforeUnmount () {
    clearInterval(this.timer)
    if (this.ro) this.ro.disconnect()
    window.removeEventListener('resize', this.layout)
  },
  methods: {
    layout () {
      const el = this.$refs.root
      if (!el) return
      const w = el.clientWidth || window.innerWidth
      const h = el.clientHeight || window.innerHeight
      const s = Math.max(w / IMG_W, h / IMG_H)
      this.scale = s
      this.ox = (w - IMG_W * s) / 2
      this.oy = (h - IMG_H * s) / 2
    },
    pickTarget () {
      const rnd = (a, b) => a + Math.random() * (b - a)
      const horizontal = Math.random() < 0.4
      let tx = this.x
      let ty = this.y
      if (horizontal) tx = rnd(BOX.x0, BOX.x1)
      else ty = rnd(BOX.y0, BOX.y1)
      tx = Math.min(BOX.x1, Math.max(BOX.x0, tx))
      ty = Math.min(BOX.y1, Math.max(BOX.y0, ty))
      return { x: tx, y: ty }
    },
    tick () {
      const now = performance.now()
      const dt = Math.min(0.2, (now - this.last) / 1000)
      this.last = now
      if (now >= this.pauseUntil) {
        if (!this.target) this.target = this.pickTarget()
        const dx = this.target.x - this.x
        const dy = this.target.y - this.y
        const dist = Math.hypot(dx, dy)
        const step = SPEED * dt
        if (dist <= step) {
          this.x = this.target.x
          this.y = this.target.y
          this.target = null
          this.pauseUntil = now + 500 + Math.random() * 900
        } else {
          this.x += (dx / dist) * step
          this.y += (dy / dist) * step
          this.facing = Math.abs(dx) > Math.abs(dy) ? (dx > 0 ? 'right' : 'left') : (dy > 0 ? 'down' : 'up')
          this.phase += dt * 6
        }
      }
      this.x = Math.min(BOX.x1, Math.max(BOX.x0, this.x))
      this.y = Math.min(BOX.y1, Math.max(BOX.y0, this.y))
      this.draw()
    },
    draw () {
      const cv = this.$refs.cv
      if (!cv) return
      const ctx = cv.getContext('2d')
      const sctx = this.sprite.getContext('2d')
      sctx.clearRect(0, 0, 16, 16)
      drawPixelPerson(sctx, 0, 0, 1, {
        role: 'self', username: '访客', isSelf: true, facing: this.facing, walkPhase: this.phase
      })
      ctx.clearRect(0, 0, IMG_W, IMG_H)
      ctx.imageSmoothingEnabled = false
      ctx.drawImage(this.sprite, Math.round(this.x), Math.round(this.y), 16 * SPRITE_SCALE, 16 * SPRITE_SCALE)
      // 仅供自动化验证（无副作用）
      const ds = this.$refs.root.dataset
      ds.fallbackPos = `${this.x.toFixed(1)},${this.y.toFixed(1)}`
      ds.fallbackLabels = '0'
    }
  }
}
</script>

<style scoped>
.hero-fb { position: absolute; inset: 0; overflow: hidden; background: #f5f5f7; pointer-events: none; }
.hero-fb__stage {
  position: absolute; left: 0; top: 0; transform-origin: 0 0;
  image-rendering: pixelated;
}
.hero-fb__cv { position: absolute; inset: 0; width: 100%; height: 100%; image-rendering: pixelated; }
</style>
